import { render } from "./TreasureView.vue?vue&type=template&id=922edb14&scoped=true"
import script from "./TreasureView.vue?vue&type=script&lang=js"
export * from "./TreasureView.vue?vue&type=script&lang=js"

import "./TreasureView.vue?vue&type=style&index=0&id=922edb14&lang=scss&scoped=true"

import exportComponent from "D:\\Code\\MonsterView\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-922edb14"]])

export default __exports__